import env from "../env"

const vars = {
  knowledge: {
    latest: 12
  },
  learning: {
    latest: 12
  },
  search: {
    results: 9
  },
  comments: {
    per_page: 9999
  },
  commentform: {
    timeout: 5000 // timeout after commentform gets flushed
  },
  notifications: {
    refreshTimeout: 60000,
    maxNotificationsBadge: 10,
    perPage: 50
  },
  cookieCheckInterval: 15000,
  cookieName: "dps_cookie_test",
  languages: {
    de: "Deutsch",
    en: "English"
  },
  defaultLangCookieName: "dps_default_lang",
  defaultLang: typeof env.LANGUAGES !== "undefined" ? env.LANGUAGES[0] : "de",
  titleSeparator: " | ",
  titleSiteName:
    typeof env.SITE_NAME !== "undefined" ? env.SITE_NAME : "abat+ Lernplattform"
}

export default vars



// WEBPACK FOOTER //
// ./src/config/vars.js